<cer-form #form [panes]="panes">
  <ng-template #mainTemplate>
    <cer-form-pane pane="main"/>
  </ng-template>
  <ng-template #bottomTemplate>
    <cer-form-pane pane="bottom"/>
  </ng-template>
  <ng-template #rightTemplate>
    <cer-app-file-viewer-tab #tabAttachments
        [token]="attachmentToken"
        [refTableId]="1" 
        [refRowId]="attachmentRefRowId"
        [attachments]="attachments"
        [tabSelectedIndexInitial]="attachmentIdxDefault"
        [enableChat]="true" [chats]="chats"
        [saveUrl]="attachmentSaveUrl"
        [removeUrl]="attachmentRemoveUrl"        
        [allowTransfer]="true"
        [tabCheckBoxAllowed]="true"
        [privateNoteActive]="true"
        (tabSelectedIndexChanged)="onAttachmentTabSelectedIndexChanged($event)"
        (viewCommand)="attachmentService.onFileViewerCommand($event)"
        (tabCheckBoxApply)="onAttachmentCheckBoxApply($event)">
      </cer-app-file-viewer-tab>
  </ng-template>
</cer-form>
